import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { DayComponentProps } from 'react-native-plain-calendar';

import { BaseText } from '../../common/BaseText';
import { Touchable } from '../../common/Touchable';

const DayComponentTouchable = styled(Touchable)(
  (props: DayComponentProps) => ({
    backgroundColor: props.isSelectedDate
      ? '$primary300'
      : '$background0',
    borderRadius: props.isSelectedDate ? 18 : 0,
    size: 36,
    alignItems: 'center',
    justifyContent: 'center',
  }),
);

const DayComponentText = styled(BaseText)(
  (props: Pick<DayComponentProps, 'isSelectedDate'>) => ({
    color: props.isSelectedDate ? '$text400' : '$heading500',
    variant: 'text.small',
  }),
);

export function CalendarDay(props: DayComponentProps) {
  if (props.isDisabledDate) {
    return <View />;
  }

  return (
    <DayComponentTouchable {...props}>
      <DayComponentText isSelectedDate={props.isSelectedDate}>
        {props.date}
      </DayComponentText>
    </DayComponentTouchable>
  );
}
